import useENotification from '../../../../../hooks/eNotification';

const path = '../oldPages/e-notification/create-new-template/index.html';

function ENotificationCreateNewTemplate() {
  const { iframeRef } = useENotification();

  return <iframe ref={iframeRef} title="e-notification-create-new-template" src={path} width="100%" height="1300px" />;
}

export default ENotificationCreateNewTemplate;
